export const LONG_DASH = '—>'

export const TNKC_TOKEN = 'tnkc_token'
export const USER_DETAILS = 'userDetails'
export const POS_CODE = 'posCode'
export const PURPOSES = 'purpose'
export const VESSELS = 'getVessels'
export const CREW = 'crew'
export const GUEST = 'guest'
export const CREW_TRAINING_DETAILS = 'getCrewTrainingDetails'
export const CREW_PCRS = 'getCrewPCRS'
export const PCR = 'viewCov19MedCert'
export const DELETE_PCR = 'deleteCov19medCert'
export const PCR_DETAILS = 'getCov19medCertDetails'
export const UPDATE_PCR = 'updateCov19medCert'
export const CREW_BOOKING = 'crewBooking'
export const CREW_LATEST_BOOKING = 'getLatestCrewBookingHistory'
export const HOTEL = 'hotel'
export const FLOOR = 'floor'
export const HOTEL_FLOORS = 'hotelFloors'
export const ALL_HOTEL_FLOORS = 'getAllHotelFloors'
export const FLOOR_ROOMS = 'floorRooms'
export const BED_ROOMS = 'bedRooms'
export const ROOM = 'room'
export const BED = 'bed'
export const ALL_ROOMS_WITH_BED = 'getRoomsAndBeds'
export const CREW_RESERVATION = 'crewReservation'
export const CREW_RESERVATION_REMARKS = 'crewReservationRemark'
export const GET_BATCH_KEY_DETAILS = 'getBatchKeyDetails'
export const GET_CREW_KEY_DETAILS = 'getCrewKeyDetails'
export const GET_HOTEL_KEY_DETAILS = 'getHotelKeyDetails'
export const GET_CREW_ENDORSE_LIST = 'getCrewEndorseList'
export const GET_RESERVATION_REMARKS = 'getCrewReservationRemarks'
export const RESERVATION_BATCH_NO = 'getBatchControlNum'
export const RESERVATION_BATCH = 'reservationBatch'
export const APPROVE_CREW_ENDORSE = 'approveCrewEndorse'
export const CANCEL_CREW_ENDORSE = 'cancelCrewEndorse'
export const IS_EXTEND_BOOKING = 'isExtend'
export const GET_CREWENDORSE_RESERVE_LIST = 'getCrewEndorseReserveList'
export const RESERVATION_KEY_DETAILS = 'reservationKeyDetails'
export const GET_FLOORS_BY_HOTEL = 'getFloorsByHotel'
export const COUNT_ROOMS_AVAILABLE = 'countRoomsAvailable'

export const GET_ROOM_FOR_BOOKING = 'getRoomsForBookingDetails'

export const BEDS_PER_ROOM = 'bedsPerRoom'
// export const BEDS_PER_ROOM_GUEST = 'bedsPerRoomGuest'; not use

export const GET_BOOKED_LIST_BY_HOTEL = 'getBookedListByHotel'
export const SET_CHECKIN_OR_CHECKOUT = 'setCheckInOrOut'
export const SET_BOOKED_EXTEND_DATE = 'setBookedExtendDate'
export const CHECK_CONFLICT = 'checkConflict'
export const REMOVE_RESERVATION = 'removeReservation'
export const TRANSFER_BOOKED = 'transferBooked'
export const GET_CHECK_IN_WEEK = 'getCheckInThisWeek'
export const GET_CHECK_OUT_WEEK = 'getCheckOutThisWeek'
export const GET_ENDORSE_WEEK = 'getEndorseThisWeek'
export const GET_ROOMS_AVAILABLE_THIS_WEEK = 'getRoomsAvailableThisWeek'
export const GUEST_BOOKING = 'guestBooking'
export const GUEST_BOOKED_IN = 'setGuestBookedIn'
export const GUEST_BOOKED_OUT = 'setGuestBookedOut'

export const GET_ALL_BOOKING_ENCODE = 'getAllBookingsEncode'
export const VIEW_BOOKING_ENCODE = 'viewBookingEncode'
export const UPDATE_BOOKING_ENCODE = 'updateBookingEncode'
export const DELETE_BOOKING_ENCODE = 'deleteBookingEncode'

export const CREATE_PENT_HOUSE_FLOOR = 'createPentHouseFloor'

export const COUNT_FOR_BOOKING = 'countForBookings'

export const SEND_MAIL = 'sendEmailCrewReservation'
export const MAILING_RESOURCE = 'mailingResource'

export const GET_USER_NOT_IN_MAILING = 'getUsersNotInMailing'

// reports
export const GET_ACTUALIZATION = 'getActualUtilization'

// TODO
export const USER_ACCOUNTS = 'userAccount'
export const CREW_RECORD = 'crewRecord'
